<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
            
            <el-col :md="6" :sm="12">
              <el-form-item label="分类名称:">
                <el-input v-model="table.where.title" placeholder="请输入分类名称" clearable/>
              </el-form-item>
            </el-col>
                                
                          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:storegoodscategory:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:storegoodscategory:dall')">批量删除
        </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
          <el-table-column prop="title" label="分类名称" show-overflow-tooltip min-width="120"/>
            <el-table-column label="图标" min-width="100" align="center">
                <template slot-scope="{row}">
                    <el-avatar shape="square" :size="35" :src="row.image"/>
                </template>
            </el-table-column>                    
                                          
          <el-table-column prop="status" label="状态" :resizable="false" min-width="120">
              <template slot-scope="{row}">
                  <el-switch v-model="row.status" @change="status(row)" :active-value="1" :inactive-value="2"/>
              </template>
          </el-table-column>
                                
          <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip min-width="180">
           <template slot-scope="scope">
                <el-button type="primary" @click="upMove(scope.$index,scope.row)">上移</el-button>
                <el-button type="primary" @click="downMove(scope.$index,scope.row)">下移</el-button>
            </template>
           </el-table-column>   
          <el-table-column label="添加时间" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:storegoodscategory:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此商品分类吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:storegoodscategory:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改商品分类':'修改商品分类'" :visible.sync="showEdit" width="450px"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        
        <el-form-item label="图标：">
            <uploadImage :limit="1" v-model="editForm.image"></uploadImage>
        </el-form-item>
                                  
        <el-form-item label="分类名称：" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入分类名称" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="状态：" prop="status">
          <el-switch
                  v-model="editForm.status"
                  active-text="开启"
                  inactive-text="关闭">
          </el-switch>
        </el-form-item>
                                                  
        <!-- <el-form-item label="排序：" prop="sort">
            <el-input-number v-model="editForm.sort" controls-position="right" :min="0"
                              placeholder="请输入排序" class="ele-fluid ele-text-left"/>
        </el-form-item> -->
                              
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
	import uploadImage from '@/components/uploadImage'
import { mapGetters } from "vuex";
export default {
  name: "SysStoreGoodsCategory",
  data() {
    return {
      table: {url: '/storegoodscategory/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
                        
        image: [
          {required: true, message: '请输入图标', trigger: 'blur'}
        ],
                                    
        title: [
          {required: true, message: '请输入分类名称', trigger: 'blur'}
        ],
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
},
  components: {uploadImage},
  mounted() {
  },
  methods: {
      upMove(index,e){
          var temp_data = {
              sort:e.sort,
              id:e.id,
              status:1,
              
          }
        this.editSort(temp_data);
          this.$refs.table.reload();
          // this.show_data[index] = this.show_data.splice(index + 1, 1, this.show_data[index])[0]
      },
      downMove(index,e){
          var temp_data = {
              sort:e.sort,
              id:e.id,
              status:2,
          }
          this.editSort(temp_data);
      },
      editSort(data){
        this.$http.post('/storegoodscategory/editSort',data).then(res => {
          if (res.data.code === 0) {
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this.$message.error(e.message);
        });  
      },
    /**
     * 显示编辑
     */
    edit(row) {
      this.$http.get('/storegoodscategory/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          this.editForm = res.data.data;
          this.editForm.status = this.editForm.status == 2 ? false : true;
          this.showEdit = true;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.$http.post('/storegoodscategory/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的商品分类吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/storegoodscategory/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/storegoodscategory/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                  
    /**
     * 更改状态
     */
    status(row) {
        const loading = this.$loading({lock: true});
        let params = Object.assign({}, row);
        this.$http.post("/storegoodscategory/status", params).then(res => {
            loading.close();
            if (res.data.code === 0) {
                this.$message({type: 'success', message: res.data.msg});
            } else {
                row.status = !row.status ? 2 : 1;
                this.$message.error(res.data.msg);
            }
        }).catch(e => {
            loading.close();
            this.$message.error(e.message);
        });
    },
        }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>